import axios from "./AxiosClient";

const url = `/api`;

const UserManagmentService = {
  createUser: (payload) => {
    return axios.post(`${url}/users`, payload);
  },
  getUsers: (page = 1, type = "internal", filterData, searchKey) => {
    const { role = "", from = "", to = "" } = filterData;
    let queryParam = "";

    if (role !== "") {
      queryParam += `&role=${role}`;
    }

    if (from !== "") {
      const fromDate = from.split("T")[0];
      queryParam += `&start_date=${fromDate}`;
    }

    if (to !== "") {
      const toDate = to.split("T")[0];
      queryParam += `&end_date=${toDate}`;
    }
    if (searchKey !== "") {
      queryParam += `&search=${searchKey}`;
    }
    return axios.get(`${url}/users?page=${page}&type=${type}${queryParam}`);
  },
  getProjectUsers: (page = 1) => {
    return axios.get(`${url}/users?page=${page}&formTypeUser=usersProjects`);
  },
  getSingleUser: (id) => {
    return axios.get(`${url}/users/${id}`);
  },
  getUserProfile: () => {
    return axios.get(`${url}/profile`);
  },
  updateUserProfile: (payload) => {
    return axios.post(`${url}/profile`, payload);
  },
  updateUser: (id, payload) => {
    return axios.patch(`${url}/users/${id}`, payload);
  },
  deleteUser: (id) => {
    return axios.delete(`${url}/users/${id}`);
  },
  changePassword: (data) => {
    return axios.post(`${url}/changePassword`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  getNotifications: () => {
    return axios.get(`${url}/notifications`);
  },
};

export default UserManagmentService;
